import React, {useEffect, useState, } from "react";
import { Space } from 'antd';
import { useDispatch } from 'react-redux';
import { getAvailability } from "../stateManagement/actions/data";
import DataAvailabilityList from "../components/sections/dataAvailabilityList";

const DataAvailabilityPage = () =>{

    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    useEffect(() => {
        dispatch(getAvailability(setData))
    }, [dispatch]);

    return(<>
        <h2>Data availability for the last 30 days:</h2>
        <Space>
            <DataAvailabilityList list={data?.imports}/>
        </Space>
    </>)
}

export default DataAvailabilityPage;